<template>
  <div class="bundle-customiser">
    <BundleCustomiserTrigger
      v-for="(collection, index) in collections"
      :key="collection?.handle ? collection.handle : collection.label"
      :collection="collection"
      :is-collection-bundle="isCollectionBundle"
      :index="index"
    />
    <template v-if="isCollectionBundle">
      <BundleCustomiserTrigger
        v-for="index in collections[0].minimumQuantity - 1"
        :key="`collection-${index}`"
        :collection="collections[0]"
        :is-collection-bundle="isCollectionBundle"
        :index="index"
      />
    </template>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { useBundleStore } from '../pinia/BundleStore'

import BundleCustomiserTrigger from './bundle-customiser-trigger'

export default {
  components: {
    BundleCustomiserTrigger
  },
  computed: {
    ...mapState (useBundleStore, [
      'bundle',
      'bundleOptions',
      'isCollectionBundle',
      'isDuo',
      'isTrio',
      'isMetafieldsMode'
    ]),
    collections() {
      if (this.bundleOptions?.length) {
        return this.bundleOptions
      }
      return null
    },
  },
}
</script>
